var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsWholeLotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_319_1384)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 18,
    stroke: "#EF814E",
    strokeWidth: 3.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 41C34.2843 41 41 34.2843 41 26C41 17.7157 34.2843 11 26 11C17.7157 11 11 17.7157 11 26C11 34.2843 17.7157 41 26 41Z",
    fill: "#EF814E",
    stroke: "#EF814E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8974 27.0004C21.5004 27.0004 22.8 25.661 22.8 24.0088C22.8 22.8892 22.2032 21.9133 21.3196 21.4004L17.2 25.1157C17.6269 26.22 18.6737 27.0004 19.8974 27.0004Z",
    fill: "#6C2C0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1026 27.0004C30.4996 27.0004 29.2 25.661 29.2 24.0088C29.2 22.8892 29.7968 21.9133 30.6804 21.4004L34.8 25.1157C34.3731 26.22 33.3263 27.0004 32.1026 27.0004Z",
    fill: "#6C2C0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8333 31.8337C31.1686 31.318 30.2928 30.8978 29.2784 30.608C28.264 30.3182 27.1402 30.167 26 30.167C24.8597 30.167 23.7359 30.3182 22.7215 30.608C21.7071 30.8978 20.8313 31.318 20.1666 31.8337",
    stroke: "#6C2C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.38 17.7838C32.7377 19.3374 33.6858 19.8848 35.7101 20.2838",
    stroke: "#6C2C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6234 17.7838C19.2657 19.3374 18.3176 19.8848 16.2933 20.2838",
    stroke: "#6C2C0E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_319_1384",
    x: 0.0000243187,
    y: 0.00039053,
    width: 52,
    height: 51.9992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2,
    result: "effect1_foregroundBlur_319_1384"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsWholeLotSelected);
export default __webpack_public_path__ + "static/media/hurts-whole-lot-selected.7aa7c8869bd63bcec5fde23acf7daee4.svg";
export { ForwardRef as ReactComponent };